module.exports = __webpack_public_path__ + "media/images/favicon-4994dc661be39d43304be2ef61280cf4.ico";